import request from '@/router/axios'
// 总代投诉工单分页
export function getGenComplainPage (query) {
    return request({
      url: '/api/generalComplaint/page-ticket',
      method: 'get',
      params: query
    })
}
// 总代投诉工单分页
export function getFacComplainPage (query) {
    return request({
      url: '/api/generalComplaint/factory/page-ticket',
      method: 'get',
      params: query
    })
}
// 工单列表
export function getComplaintIssues (query) {
    return request({
      url: '/api/generalComplaint/listComplaintIssues',
      method: 'get',
      params: query
    })
}
// 店铺投诉详情
export function shopComplaintdetail (id) {
    return request({
      url: '/api/shopComplaint/' + id,
      method: 'get',
    })
}
// 区代投诉详情
export function areaComplaintdetail (id) {
    return request({
      url: '/api/areaComplaint/' + id,
      method: 'get',
    })
}
// 总代投诉详情
export function generalComplaintdetail (id) {
    return request({
      url: '/api/generalComplaint/' + id,
      method: 'get',
    })
}
// 店铺转总代
export function shopTranferGen (obj) {
  return request({
    url: '/api/shopComplaint/general-accept',
    method: 'post',
    data: obj
  })
}
// 区代转总代
export function areaTranferGen (obj) {
  return request({
    url: '/api/areaComplaint/general-accept',
    method: 'post',
    data: obj
  })
}
// 店铺受理投诉
export function shopComplaintaccept (obj) {
  return request({
    url: '/api/shopComplaint/accept',
    method: 'post',
    data: obj
  })
}
// 区代受理投诉
export function areaComplaintaccept (obj) {
  return request({
    url: '/api/areaComplaint/accept',
    method: 'post',
    data: obj
  })
}
// 总代受理投诉
export function generalComplaintaccept (obj) {
  return request({
    url: '/api/generalComplaint/accept',
    method: 'post',
    data: obj
  })
}
// 店铺投诉修改
export function shopComplaintEdit (obj) {
  return request({
    url: '/api/shopComplaint',
    method: 'put',
    data: obj
  })
}
// 区代投诉修改
export function areaComplaintEdit (obj) {
  return request({
    url: '/api/areaComplaint',
    method: 'put',
    data: obj
  })
}
// 总代投诉修改
export function generalComplaintEdit (obj) {
  return request({
    url: '/api/generalComplaint',
    method: 'put',
    data: obj
  })
}
//总代取消投诉
export function generalComplaintcancel (query) {
  return request({
    url: '/api/generalComplaint/cancel',
    method: 'post',
    data: query
  })
}


// 处理店铺投诉
export function shopComplaintProcess (obj) {
  return request({
    url: '/api/shopComplaint/process',
    method: 'post',
    data: obj
  })
}
// 处理区代投诉
export function areaComplaintProcess (obj) {
  return request({
    url: '/api/areaComplaint/process',
    method: 'post',
    data: obj
  })
}
// 处理总代投诉
export function generalComplaintProcess (obj) {
  return request({
    url: '/api/generalComplaint/process',
    method: 'post',
    data: obj
  })
}
// 总代投诉分页
export function getGenComplainMinePage (query) {
  return request({
    url: '/api/generalComplaint/page',
    method: 'get',
    params: query
  })
}
// 投诉对象列表
export function listComplaintObject (query) {
  return request({
    url: '/api/generalComplaint/listComplaintObject',
    method: 'get',
    params: query
  })
}
// 总代投诉新增
export function generalComplaintpost (obj) {
  return request({
    url: '/api/generalComplaint',
    method: 'post',
    data: obj
  })
}

export function getShopComplainMinePage (query) {
  return request({
    url: '/api/shopComplaint/page',
    method: 'get',
    params: query
  })
}
// 投诉对象列表

// dianpu投诉新增
export function shopComplaintpost (obj) {
  return request({
    url: '/api/shopComplaint',
    method: 'post',
    data: obj
  })
}


//总代取消投诉
export function shopComplaintcancel (query) {
  return request({
    url: '/api/shopComplaint/cancel',
    method: 'post',
    data: query
  })
}